import { IconProps } from "@/types/types";

export default function Fire({ width = "24", height = "24" }: IconProps) {
    return (
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.25 13.7502C20.25 18.3066 16.5563 22.0002 12 22.0002C7.44365 22.0002 3.75 18.3066 3.75 13.7502C3.75 8.06542 8.18894 3.86028 10.5547 2.0228C11.1702 1.54478 12 1.99631 12 2.77559V7.75021C12 8.71671 12.7835 9.50021 13.75 9.50021C14.7165 9.50021 15.5 8.71671 15.5 7.75021V7.50021C15.5 6.93099 16.0907 6.56163 16.5646 6.87697C18.7861 8.35524 20.25 10.8818 20.25 13.7502Z" fill="currentColor" />
        </svg>

    )
}

